"use client";

import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";
import Link from "next/link";
import { useEffect } from "react";

export default function GlobalError({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("Global error:", error);
	}, [error]);

	return (
		<div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50/30 flex items-center justify-center p-4">
			<div className="max-w-md w-full text-center">
				<div className="bg-white/80 backdrop-blur-xl border border-white/50 shadow-2xl rounded-3xl p-8 md:p-10">
					<div className="w-16 h-16 bg-red-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
						<AlertTriangle className="w-8 h-8 text-red-600" />
					</div>

					<h1 className="font-display font-bold text-2xl md:text-3xl text-gray-900 mb-3">
						Something went wrong
					</h1>

					<p className="text-gray-600 mb-8">
						An unexpected error occurred. Please try again or contact support if
						the problem persists.
					</p>

					<div className="flex flex-col sm:flex-row gap-3 justify-center">
						<Button
							onClick={reset}
							className="h-12 bg-brand-blue hover:bg-indigo-600 text-white font-bold rounded-xl shadow-lg shadow-brand-blue/20 transition-all"
						>
							<RefreshCw className="w-4 h-4 mr-2" />
							Try again
						</Button>

						<Button
							asChild
							variant="outline"
							className="h-12 border-gray-200 hover:bg-gray-50 font-semibold rounded-xl"
						>
							<Link href="/">Go home</Link>
						</Button>
					</div>

					{error.digest && (
						<p className="mt-6 text-xs text-gray-400">
							Error ID: {error.digest}
						</p>
					)}
				</div>
			</div>
		</div>
	);
}
